import * as types from '../mutation-types'

const state = {
    count: 10,
    haveNewOrUpdateShop:false,
    addNewAccount:{
        plat: '',
        currency: '',
        area: '',
        nickName: '',
    }
}

// 初始计算state
const getters = {
    count:function(state){
        return state.count;
    },
}

// 同步事件
const mutations={
    add(state,n){
        state.count+=n;
    },
    reduce(state){
        state.count-=1;
    },
    showShopTip(state){
        state.haveNewOrUpdateShop = true;
    },
    addNewAccount(state,jsonMes){
        state.addNewAccount.plat = jsonMes.plat?jsonMes.plat:'';
        state.addNewAccount.currency = jsonMes.currency?jsonMes.currency:'';
        state.addNewAccount.area = jsonMes.area?jsonMes.area:"";
        state.addNewAccount.nickName = jsonMes.nickName?jsonMes.nickName:'';
    }
}

// 异步事件
const actions ={
	// 两种写法
    // addAction(context,n){
    //     context.commit('add',n)
    // },

    addAction({commit},n){
        commit('add',n)
    },

    // 常用
    reduceAction({commit}){
        commit('reduce')
        //setTimeout(()=>{commit('reduce')},1000); //异步模拟
    },
    incrementWithValue({commit}, value){
        commit("INCREMENT_WITH_VALUE",  parseInt(value))
    },

    // 侧边栏显示隐藏
    handleAction({commit}){
        commit('handle')
    },
}

export default({
    //namespaced: true, //命名空间开启
    state,
    getters,
    actions,
    mutations
})

